import { useState } from 'react';
import { useSearchParams } from 'react-router';

import { Input } from '@/components/form/Input';
import { Button } from '@/components/ui/button';
import { Disclaimer } from '@/sections/signup/Disclaimer';
import { PageWrapper } from '@/sections/signup/PageWrapper';
import { SignupError } from '@/sections/signup/SignupError';
import { useDomainSsoSignIn } from '@/sections/signup/useDomainSsoSignIn';

export const LoginSSO = () => {
  const [username, setUsername] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const domainSsoSignIn = useDomainSsoSignIn();

  const handleSignin = async () => {
    setError('');

    const domain = getEmailDomain(username);
    if (!domain) {
      setError('Enter a valid email address to continue with SSO.');
      return;
    }

    setIsSubmitting(true);
    const result = await domainSsoSignIn(domain, searchParams.get('redirect'));
    if (result === 'not-configured') {
      setError('SSO is not configured for this email domain.');
    } else if (result === 'error') {
      setError(`Unable to verify SSO configuration for ${domain}.`);
    }
    setIsSubmitting(false);
  };

  function getEmailDomain(email: string): string {
    const parts = email.trim().toLowerCase().split('@');
    if (parts.length !== 2 || !parts[0] || !parts[1]) {
      return '';
    }
    return parts[1];
  }

  return (
    <PageWrapper title="Sign in with SSO" showBack={true}>
      <form
        className="flex flex-1 flex-col gap-4 space-y-4 p-2"
        id="signup"
        onSubmit={e => {
          e.preventDefault();
          handleSignin();
        }}
      >
        <Input
          label={'Email Address'}
          value={username}
          placeholder={'victoria@praetorian.com'}
          name={'username'}
          required={true}
          onChange={e => {
            setUsername(e.target.value);
          }}
        />
        <SignupError error={error} />
        <Button
          className="w-full"
          type="submit"
          id="signup"
          disabled={isSubmitting}
        >
          Continue
        </Button>
        <Disclaimer />
      </form>
    </PageWrapper>
  );
};
